<script>

    // -- IMPORTS
    
	import LayoutSelect from './../newBlockModal/layoutSelect.svelte';
    import { getJsonText, getLocalizedText } from 'senselogic-gist';
    import { languageArrayStore } from '$store/languageArrayStore';
    import Input from './Input.svelte';
    import FileInput from './FileInput/FileInput.svelte';
    import InputLocalizedForm from './InputLocalizedForm.svelte';
    import ArrayEditor from './ArrayEditor.svelte';
    import { fetchData, addFileArrayOnObject } from '../../base';
    import { onMount } from 'svelte';
    import { isLoadingStore } from '../../store/isLoadingStore';
    import { toast } from '$src/lib/toast';
    import Select from './Select.svelte';
    import CardGroupManager from '../newBlockModal/cardGroupManager.svelte';

    // -- CONSTANTS

    let mediaAndTextFieldArray = [
        'text-and-media', 
        'media-and-text', 
        'text-and-media-vertical', 
        'media-and-text-vertical'
    ];

    // -- VARIABLES

  /** @type {{pageId?: string, blockData?: any, isManager?: boolean, onBlockCreated?: () => void }} */
    let 
    {     
        pageId = '', 
        blockData = 
        {
            id : '',
            slug : 'new',
            typeSlug : 'text-and-media',
            number : 0,
            sectionPositionNumber : 0,
            isActive : true,
            title : null,
            text : null,
            textArray: [],
            subTitle : null,
            description : null,
            mediaPath : null,
            mediaPathArray : [],
            imageAlt : null,
            imagFit : null,
            imageHorizontalPosition : null,
            imageVerticalPosition : null,
            imageSide: 'right',
            imageLegend: null
        }, 
        isManager = false,
        onBlockCreated = () => {}
    } = $props();

    let form = $state();
    let folderPath = 'block/'
                      + blockData?.slug?.toLowerCase().replaceAll("-", "_")
                      + '/';
    let fileArray = $state([]);
    let blockForm = $state( blockData );
    let isSubmitting = false;

    // -- FUNCTIONS

    function setDefaultFileArray(
        )
    {
        if ( blockData?.mediaPath !== null 
             && blockData?.mediaPath !== '' )
        {
            fileArray = [ blockData.mediaPath ];
        }
        else
        {
            fileArray = blockData.mediaPathArray ?? [];
        }
    }

    // ~~

    function handleUpdateLocalizedInput(
        event
        )
    {

        blockForm[ event.detail.name ] = JSON.stringify( event.detail.text );
    }

    // ~~

    function handleSaveTextArray( event )
    {
        blockForm[ 'textArray' ] = JSON.parse( event.textArray );
    }

    // ~~

    function handleSaveCardArray( event )
    {
        blockForm[ 'blockArray' ] = event.cardArray;
    }


    // ~~

    function checkFieldByType(
        blockForm
        )
    {
        let haveNoTitleOrText = !blockForm.title 
                                && !blockForm.text;

        let hasCTAIncomplete = ( blockForm.teaser && !blockForm.href ) 
                               || ( blockForm.href && !blockForm.teaser );

        let hasImage = ( fileArray.length > 0 );

        if( blockForm.slug === 'new' )
        {
            toast.error( 'Please add descriptive slug' );

            return true;
        }

        if( mediaAndTextFieldArray.includes( blockForm.typeSlug ) )
        {
            if( haveNoTitleOrText )
            {
                toast.error( 'Please add a title or a text, or change for image' );

                return true;
            }
            else if( hasCTAIncomplete )
            {
                toast.error( 'Please add the CTA and the destination' );

                return true;
            }
            else if( !hasImage )
            {
                toast.error( 'Please add a image or change for text' );

                return true;
            }
        }
        else if( blockForm.typeSlug === 'media' )
        {
            if( !hasImage )
            {
                toast.error( 'Please add a image or change for text' );

                return true;
            }
        }
        else if( blockForm.typeSlug === 'text' )
        {
            if( haveNoTitleOrText )
            {
                toast.error( 'Please add a title or a text, or change for image' );

                return true;
            }
            else if( hasCTAIncomplete )
            {
                toast.error( 'Please add the CTA, Destination also Title or text' );

                return true;
            }
        }
        else if( blockForm.typeSlug === 'list' )
        {
            if( blockForm.textArray?.length <= 0 )
            {
                toast.error( 'Please add at least one text' );

                return true;
            }
        }
        else if( blockForm.typeSlug === 'card-group' )
        {
            if( blockForm.blockArray.length < 2 )
            {
                toast.error( 'Card group should have atleast 2 cards' );

                return true;
            }
            
            let cardsResponse = 
                blockForm.blockArray.map(
                    ( block, index ) => 
                    {
                        if( !block.title 
                            && !block.text )
                        {
                            toast.error( 'Please add a title or a text, or change for image on card ' + index );

                            return true;
                        }
                        else if(( block.teaser && !block.href ) 
                                || ( block.href && !block.teaser ))
                        {
                            toast.error( 'Please add the CTA and the destination on card ' + index );

                            return true;
                        }

                        return false;
                    }
                );

            if( cardsResponse === true )
            {
                toast.error('error adding card group')

                return true;
            }
        }
    }

    // ~~

    function checkManagerError(
        blockForm
        )
    {
        let haveNoTitleOrText = !blockForm.name 
                                && !blockForm.position
                                && !blockForm.biography;
                    
        let hasImage = ( fileArray.length > 0 );

        if( haveNoTitleOrText )
        {
            toast.error( 'Please add a Name, Position, or Biography' );

            return true;
        }
        else if( !hasImage )
        {
            toast.error( 'Please add a image' );

            return true;
        }
    }

    // ~~

    async function handleSubmit( 
        event 
        )
    {
        event.preventDefault();

        $isLoadingStore = true;

        try
        {
            if ( !event )
            {
                return;
            }

            let formData = new FormData();
            
            blockForm = addFileArrayOnObject( blockForm, fileArray );

            let textSlugByTitle = getLocalizedText( blockForm.title ).toLowerCase().replaceAll( ' ', '-' ).replaceAll("\"", "");

            blockForm.textArray = blockForm.textArray.map(( text ) => `* ${ text }` );
            blockForm.imageSide = blockForm.typeSlug === "text-and-media" 
                                    ? "right"
                                    : "left";

            blockForm = {
                ...blockForm,
                pageId: pageId,
                slug: blockForm.slug || textSlugByTitle,
            }

            let hasError = checkFieldByType( blockForm );

            if( hasError )
            {
                $isLoadingStore = false;

                return;
            }

            for ( let [ key, value ] of Object.entries( blockForm ) )
            {
                if ( key.includes( 'Array' ) 
                     || Array.isArray( value ) )
                {
                    formData.append( key, getJsonText( value ) )
                }
                else
                {
                    formData.append( key, value )
                }
            }

            let response =
                await fetchData(
                    blockForm.typeSlug === 'card-group' 
                        ? '/api/block/add-many'
                        : '/api/block/add',
                    {
                        method: 'POST',
                        body: formData,
                        credentials: 'include',
                    }
                    );

            if ( response.error )
            {
                toast(
                    {
                        variant: 'error',
                        text: 'Something went wrong'
                    }
                    );
            }
            else if( response.authError )
            {
                toast(
                    {
                        variant: 'error',
                        text: response.authError
                    }
                    );
            }
            else
            {
                toast(
                    {
                        variant: 'success',
                        text: response.message
                    }
                    );

                    onBlockCreated()
            }
        }
        catch ( error )
        {
            toast(
                {
                    variant: 'error',
                    text: 'Error saving your block'
                }
                );
            console.log( error );
        }
        finally
        {
            $isLoadingStore = false;
            setDefaultFileArray();
        }
    }

    // ~~

    async function handleSubmitManager(
        event
        )
    {
        event.preventDefault();

        $isLoadingStore = true;
        
        let formData = new FormData();
        let hasError = checkManagerError( blockForm );

        if( hasError )
        {
            $isLoadingStore = false;

            return;
        }

        for ( let [ key, value ] of Object.entries( blockForm ) )
            {
                if ( key.includes( 'Array' ) 
                     || Array.isArray( value ) )
                {
                    formData.append( key, getJsonText( value ) )
                }
                else
                {
                    formData.append( key, value )
                }
            }

        let response =
            await fetchData(
                '/api/team-member/add',
                {
                    method: 'POST',
                    body: formData,
                    credentials: 'include'
                }
                );

        if ( response.error )
        {
            toast(
                {
                    variant: 'error',
                    text: response.error
                }
                );
            $isLoadingStore = false;
        }
        else
        {            
            toast(
                {
                    variant: 'success',
                    text: response.message
                }
            );
            setDefaultFileArray();
            $isLoadingStore = false;

            setTimeout( onBlockCreated, 1000 );
        }
    }

    // ~~

    function customSubmit(
        event
        )
    {
        if ( form )
        {
            let fakeSubmitEvent = new Event('submit', { bubbles: true, cancelable: true } );
            form.dispatchEvent( fakeSubmitEvent );
        }
    }

    // -- STATEMENTS

    onMount( 
        () =>
        {
            setDefaultFileArray();

            window.addEventListener(
                'on-save-block',
                customSubmit
                );
            isSubmitting

            return () => {
                    window.removeEventListener( 'on-save-block', customSubmit );
                }
        }
    );
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';
    @import '../../../element.styl';

    // -- ELEMENTS

    form
    {
        width: 100%;
        padding: 1.5rem;

        display: flex;
        flex-direction: column;
        gap: 1rem;

        +media( tablet )
        {
            padding: 1rem 2.5rem;
        }

        +media( desktop )
        {
            padding: 1.5rem 3rem;
        }
    }

    option
    {
        color: lightGreyColor;
    }

    // -- CLASSES

    .card-form-inputs-container

    {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .form-items
    {
        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 2rem;
    }

    .block-section
    {
        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .buttons-container
    {
        margin-top: 1rem;
        width: 100%;

        display: flex;
        gap: 1rem;
    }
</style>

<form
    onsubmit={ isManager ? handleSubmitManager : handleSubmit }
    bind:this={ form }
>
    <div class="card-form-inputs-container">
        <div class="form-items">
            <div 
                class="block-section" 
                style={ isManager ? "padding-bottom: 1.25rem; border-bottom: 1px solid #66696C;" : '' }
            >
                {#if !isManager}
                    <Input
                        label={ 'Slug' }
                        id="slug"
                        helperText="The format must be like this: what-is-bamhub-block"
                        fullWidth
                        bind:value={ blockForm.slug }
                    />
                {/if}

                <Input
                    label={ 'Section Number' }
                    id="number"
                    type="number"
                    helperText="Section Number is used to define which section the block belongs to in the page"
                    fullWidth
                    bind:value={ blockForm.number }
                />

                {#if blockForm.typeSlug !== 'card-group'}
                    <Input
                        label={ 'Position in Section' }
                        id="sectionPositionNumber"
                        type="number"
                        helperText="Position in Section is used to define where the block is placed inside the section"
                        fullWidth
                        bind:value={ blockForm.sectionPositionNumber }
                    />
                {/if}

                {#if isManager}
                    <Select
                        name="imageSide"
                        label="Image side"
                        bind:value={ blockForm[ 'imageSide' ] }
                        fullWidth
                    >
                        {#each [ 'left', 'right' ] as imageSideOption }
                            <option value={ imageSideOption } selected={ imageSideOption === blockForm[ 'imageSide' ] }>
                                { imageSideOption }
                            </option>
                        {/each}
                    </Select>
                {/if}
            
                {#if !isManager}
                    <LayoutSelect 
                        bind:layoutType={ blockForm.typeSlug }
                    />
                {/if}

                <!-- {#if !isManager}
                    <Select
                        name="imageFit"
                        label="Image fit"
                        bind:value={ blockForm[ 'imageFit' ] }
                        fullWidth
                    >
                        {#each [ 'cover', 'contain' ] as imageFitOption }
                            <option value={ imageFitOption } selected={ imageFitOption === blockForm[ 'imageFit' ] }>
                                { imageFitOption }
                            </option>
                        {/each}
                    </Select>
                {/if} -->
            </div>

            {#if isManager}
                <Input label="Name" id="name" bind:value={ blockForm[ 'name' ] } fullWidth/>
                <Input label="Linkedin" id="linkedin" bind:value={ blockForm[ 'linkedinLink' ] } fullWidth/>
                <Input label="Instagram" id="instagram" bind:value={ blockForm[ 'instagramLink' ] } fullWidth/>
                <Input label="Email" id="email" bind:value={ blockForm[ 'emailAddress' ] } fullWidth/>

                <InputLocalizedForm
                    itemsString={ blockForm[ 'position' ] }
                    languageArray={ $languageArrayStore }
                    name="position"
                    onUpdate={ handleUpdateLocalizedInput }
                    placeholder="Role"
                />

                <InputLocalizedForm
                    isMultiLine
                    itemsString={ blockForm[ 'biography' ] }
                    languageArray={ $languageArrayStore }
                    name="biography"
                    onUpdate={ handleUpdateLocalizedInput }
                    placeholder="Biography"
                />

                <div class="block-section">
                    <h2>Media</h2>
                    <FileInput
                        bind:fileArray={ fileArray }
                        fileInputName="image-path"
                        acceptedType="image/*, video/*"
                        maxFileCount={ 5 }
                        filePath={ folderPath }
                    />
                </div>
            {:else if mediaAndTextFieldArray.includes( blockForm.typeSlug )}
                <div class="block-section">
                    <InputLocalizedForm
                        itemsString={ blockForm.title }
                        languageArray={ $languageArrayStore }
                        name={ 'title' }
                        onUpdate={ handleUpdateLocalizedInput }
                        placeholder={ 'title' }
                    />
                    
                    <InputLocalizedForm
                        isMultiLine
                        itemsString={ blockForm.text }
                        languageArray={ $languageArrayStore }
                        name={ 'text' }
                        onUpdate={ handleUpdateLocalizedInput }
                        placeholder={ 'text' }
                    />
                    
                    <InputLocalizedForm
                        itemsString={ blockForm.teaser }
                        languageArray={ $languageArrayStore }
                        name={ 'teaser' }
                        onUpdate={ handleUpdateLocalizedInput }
                        placeholder={ 'Call to action' }
                    />

                    <InputLocalizedForm
                        itemsString={ blockForm.href }
                        languageArray={ $languageArrayStore }
                        name={ 'href' }
                        onUpdate={ handleUpdateLocalizedInput }
                        placeholder={ 'Destination' }
                    />
                </div>

                <div class="block-section">
                    <h2>Media</h2>
                    <FileInput
                        bind:fileArray={ fileArray }
                        fileInputName="image-path"
                        acceptedType="image/*, video/*"
                        maxFileCount={ 5 }
                        filePath={ folderPath }
                    />
                </div>
            {:else if blockForm.typeSlug === 'media'}
                <div class="block-section">
                    <h2>Media</h2>
                    
                    <FileInput
                        bind:fileArray={ fileArray }
                        fileInputName="image-path"
                        acceptedType="image/*, video/*"
                        maxFileCount={ 5 }
                        filePath={ folderPath }
                    />
                </div>
            {:else if blockForm.typeSlug === 'text'}
                <div class="block-section">
                    <InputLocalizedForm
                        itemsString={ blockForm.title }
                        languageArray={ $languageArrayStore }
                        name={ 'title' }
                        onUpdate={ handleUpdateLocalizedInput }
                        placeholder={ 'title' }
                    />
                    
                    <InputLocalizedForm
                        isMultiLine
                        itemsString={ blockForm.imageLegend }
                        languageArray={ $languageArrayStore }
                        name={ 'imageLegend' }
                        onUpdate={ handleUpdateLocalizedInput }
                        placeholder={ 'Subtitle' }
                    />
                    
                    <InputLocalizedForm
                        isMultiLine
                        itemsString={ blockForm.text }
                        languageArray={ $languageArrayStore }
                        name={ 'text' }
                        onUpdate={ handleUpdateLocalizedInput }
                        placeholder={ 'text' }
                    />
                    
                    <InputLocalizedForm
                        itemsString={ blockForm.teaser }
                        languageArray={ $languageArrayStore }
                        name={ 'teaser' }
                        onUpdate={ handleUpdateLocalizedInput }
                        placeholder={ 'Call to action' }
                    />

                    <InputLocalizedForm
                        itemsString={ blockForm.href }
                        languageArray={ $languageArrayStore }
                        name={ 'href' }
                        onUpdate={ handleUpdateLocalizedInput }
                        placeholder={ 'Destination' }
                    />
                </div>
            {:else if blockForm.typeSlug === 'list'}
                <div class="block-section">
                    <InputLocalizedForm
                        itemsString={ blockForm.title }
                        languageArray={ $languageArrayStore }
                        name={ 'title' }
                        onUpdate={ handleUpdateLocalizedInput }
                        placeholder={ 'title' }
                    />
                    
                    <div class="block-section">
                        <h2>Multiple Texts</h2>
                        <ArrayEditor bind:data={ blockForm.textArray } saveTextArray={ handleSaveTextArray }/>
                    </div>
                </div>
            {:else if blockForm.typeSlug === 'card-group'}
                <div class="block-section">
                    <CardGroupManager saveCardArray={ handleSaveCardArray } />
                </div>
            {/if}
        </div>
    </div>
</form>
